export class ListTableMaintenanceRunsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "tableMaintenanceRuns",
            "baseName": "tableMaintenanceRuns",
            "type": "Array<MaintenanceRun>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListTableMaintenanceRunsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
